<!-- src/components/mailer/MailerAccessState.vue -->
<template>
  <section class="card">
    <div class="card-content">
      <span class="card-title">
        {{ title }}
      </span>

      <p
        :class="{
          'red-text text-darken-2': error,
        }"
      >
        {{ message }}
      </p>
    </div>
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: "Mailer",
  },

  message: {
    type: String,
    default: "",
  },

  error: {
    type: Boolean,
    default: false,
  },
});
</script>
